import { ITheme } from "cayo.ui";
import styled from "styled-components";

export const columnFilterFieldStyles = (theme: ITheme) => ({
  root: {
    width: "100%",
    minWidth: 0,
    boxSizing: "border-box",
  },
  fieldGroup: {
    minHeight: 22,
    height: 22,
    width: "100%",
    margin: 0,
    boxSizing: "border-box",
    borderColor: `${theme.cayoTheme.brandColors.divider} `,
  },
  field: {
    fontSize: 12,
    paddingRight: 20,
  },
});

export const clearButtonStyles = () => ({
  root: {
    width: 18,
    height: 18,
    minWidth: 18,
  },
  rootHovered: {
    background: "transparent",
  },
  rootPressed: {
    background: "transparent",
  },
  icon: {
    fontSize: 10,
  },
});

export const ClearButtonWrap = styled.div`
  position: absolute;
  top: 50%;
  right: 2px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
`;

export const FieldWrap = styled.div`
  position: relative;
  width: 100%;
`;
